<template>
  <nav>
    <div class="hidden-sm-and-down">
      <v-app-bar app dense>
        <v-toolbar-title class="text-uppercase grey--text mr-2 mt-1 body-1" style="cursor:pointer" @click="show_jobs">
          <span>
            <v-avatar width="32px" height="32px" min-width="32px" class="gm-logo" tile>
              <img src="/logo_gm_bw.png" alt="avatar">
            </v-avatar>
          </span>
          <span v-if="show_nav" class="pl-2">Envoy Mobile</span>
          <span v-else class="pl-2">GridMarkets Envoy Mobile</span>
          <!--span class="font-weight-light pl-2">Grid</span>
          <span>Markets</span-->
        </v-toolbar-title>
        <v-toolbar-items v-if="show_nav && ispassword">
          <v-btn class="menu_btn px-1" text small to="/submissions">
            <v-icon class="px-1">list</v-icon>
            Submissions
          </v-btn>
          <v-btn class="menu_btn px-1" text small @click="show_support">
            <v-icon class="px-1">contact_support</v-icon>
            Support
          </v-btn>
          <v-btn class="menu_btn px-1" text small @click="show_kb">
            <v-icon class="px-1">chrome_reader_mode</v-icon>
            Knowledge Base
          </v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <GMbar :key="`${profile_timestamp}`" :profile_details="profile_details" :load_profile="load_profile" />
        <v-menu
          v-if="show_nav"
          bottom
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              text
              v-bind="attrs"
              v-on="on"
              class="ml-1 px-1 primary caption"
            >
              <v-icon small left class="mx-0">person</v-icon>
              {{user_name}}
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item v-if="ispassword" link @click="show_profile">
              <v-list-item-title><v-icon small left>edit</v-icon>Profile</v-list-item-title>
            </v-list-item>
            <v-list-item link @click="logout">
              <v-list-item-title><v-icon small left>exit_to_app</v-icon>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
    </div>
    <div class="hidden-md-and-up">
      <v-app-bar app dense>
        <v-app-bar-nav-icon v-if="show_nav" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title class="text-uppercase grey--text ma-0 pa-0 body-1" style="cursor:pointer" @click="show_jobs">
          <span>
            <v-avatar width="32px" height="32px" min-width="32px" class="gm-logo" tile>
              <img src="/logo_gm_bw.png" alt="avatar">
            </v-avatar>
          </span>
          <span v-if="show_nav" class="pl-2">Envoy Mobile</span>
          <span v-else class="pl-2">GridMarkets Envoy Mobile</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu
          v-if="show_nav"
          bottom
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              text
              v-bind="attrs"
              v-on="on"
              class="ml-1 px-1 primary caption"
            >
              <v-icon small left class="mx-0">person</v-icon>
              {{user_name}}
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item v-if="ispassword" link @click="show_profile">
              <v-list-item-title><v-icon small left>edit</v-icon>Profile</v-list-item-title>
            </v-list-item>
            <v-list-item link @click="logout">
              <v-list-item-title><v-icon small left>exit_to_app</v-icon>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <v-app-bar v-if="show_nav" app dense class="mt-12 text-right grey darken-3" height="32px;">
        <v-spacer></v-spacer>
        <GMbar :key="`${profile_timestamp}`" :profile_details="profile_details" :load_profile="load_profile" />
      </v-app-bar>
      <v-navigation-drawer
        v-if="show_nav"
        v-model="drawer"
        absolute
        temporary
      >
        <v-app-bar>
          <v-toolbar-title class="text-uppercase grey--text body-1" style="cursor:pointer" @click="show_jobs">
            <span>
              <v-avatar width="32px" height="32px" min-width="32px" class="gm-logo" tile>
                <img src="/logo_gm_bw.png" alt="avatar">
              </v-avatar>
            </span>
            <span class="font-weight-light pl-2">Grid</span>
            <span>Markets</span>
          </v-toolbar-title>
        </v-app-bar>
        <v-list
          nav
          dense
        >
          <v-list-item-group
            v-model="group"
          >
            <v-list-item to="/">
              <v-list-item-title>
                <v-icon small left>mdi-group</v-icon>
                Projects
              </v-list-item-title>
            </v-list-item>

            <v-list-item to="/submissions">
              <v-list-item-title>
                <v-icon small left>mdi-group</v-icon>
                Submissions
              </v-list-item-title>
            </v-list-item>

            <v-list-item to="/profile">
              <v-list-item-title>
                <v-icon small left>edit</v-icon>
                Profile
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-footer app padless outlined>
          <v-list dense>
            <v-list-item link @click="logout">
              <v-list-item-title><v-icon small left>exit_to_app</v-icon>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-footer>
      </v-navigation-drawer>
    </div>
  </nav>

</template>

<script>
import GMbar from './GMbar'
import axios from 'axios';

export default {
  components: { GMbar },
  data() {
    return {
      page_title: "",
      user_menu: false,
      user_name: "",
      drawer: false,
      group: null,
      current_user: "",
      snackbar: false,
      show_nav: false,
      ispassword: false,
      profile_tout: null,
      profile_details: null,
      profile_timestamp: Date.now()
    }
  },
  watch: {
    group () {
      this.drawer = false
    },
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
      .then(() => this.$router.push('/login'))
    },
    show_jobs: function (){
      this.$router.push('/')
    },
    show_envoy: function (){
      this.$router.push('/envoy')
    },
    show_support: function (){
      axios.get(`https://${this.$buyerAPI}/support`)
      .then(resp => {
        let support_home_page_url = resp.data.data.support_home_page_url || null;
        if (support_home_page_url){
          window.open(support_home_page_url);
        }
      })
      .catch(() => {})
    },
    show_kb: function (){
      axios.get(`https://${this.$buyerAPI}/support`)
      .then(resp => {
        let support_getting_started_page_url = resp.data.data.support_getting_started_page_url || null;
        if (support_getting_started_page_url){
          window.open(support_getting_started_page_url);
        }
      })
      .catch(() => {})
    },
    show_profile (){
      this.$router.push('/profile');
    },
    load_profile() {
      axios.get(`https://${this.$buyerAPI}/accounts?detailed=1`)
      .then(resp => {
        this.profile_details = resp.data.data;
        let name = this.profile_details.name || null;
        if (name) this.user_name = name;
        this.profile_timestamp = Date.now();
      })
      .catch(() => {})
    },
  },
  computed : {
    userLoggedIn : function() { return this.$store.getters.userLoggedIn}
  },
  created() {
    this.page_title = this.$route.name;
    this.show_nav = ["login", "register"].indexOf(this.$route.name) > -1 ? false : true;
    
    if (this.userLoggedIn.ispassword){
      this.ispassword = true;
    }

    if (this.show_nav){
      this.load_profile();
    }
  }
}
</script>

<style scoped>
  .notification{
    max-width:350px;
  }
  .project.Completed{
    border-left: 4px solid #3cd1c2;
  }
  .project.Terminated{
    border-left: 4px solid #ffaa2c;
  }
  .project.Failed{
    border-left: 4px solid #f83e70;
  }
  .v-btn.menu_btn{
   font-size: 12px; 
  }
</style>